module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/qkKRLD/tc-custom/9781680571288.jpg?1734031081969",
      "alt": "This image is the cover for the book Drumbeats"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Drumbeats\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This dark fantasy set in Africa is a collaboration between a "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author and the drummer from the multi-platinum rock band, Rush.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" A chilling tale of African drums and human souls from #1 international bestselling author Kevin J. Anderson and legendary Rush lyricist and drummer Neil Peart."), _c('br'), _c('br'), _vm._v(" Early in their three decades of correspondence, Neil Peart sent Kevin J. Anderson extensive descriptions and travelogues of his adventures bicycling solo across Africa. Peart painted a vivid and unsettling landscape as memorable as the lyrics to his songs."), _c('br'), _c('br'), _vm._v(" Anderson, award-winning and bestselling fantasy and science fiction author, used those descriptions as the backdrop for plotting an intense, atmospheric dark fantasy story that followed Peart’s experiences, though with a much more ominous twist. The two used their respective strengths to weave a memorable tale that will linger long after the last page."), _c('br'), _c('br'), _vm._v(" This special illustrated edition includes Anderson’s new introduction, written after Peart’s death on January 7, 2020, as well as the original Afterword Peart wrote for the story. \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kevin J. Anderson, Neil Peart\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0